var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkSmall = function SvgCheckmarkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.965 14.387-1.798-1.799c-.52-.52-1.36-.52-1.88 0s-.52 1.36 0 1.88l2.745 2.745c.52.52 1.36.52 1.88 0l7.742-7.742c.52-.52.52-1.36 0-1.88s-1.36-.52-1.88 0z"
  })));
};
export default SvgCheckmarkSmall;